import { styled } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, Typography, Grid } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiBackdrop-root': {
        backgroundColor: theme.palette.mode === 'dark'
            ? 'rgba(0, 0, 0, 0.6)'
            : 'rgba(0, 0, 0, 0.4)'
    },
    '& .MuiDialog-container': {
        padding: theme.spacing(2)
    },
    '& .MuiDialog-paper': {
        borderRadius: '8px',
        maxWidth: '600px',
        width: '100%',
        margin: theme.spacing(2),
        backgroundColor: theme.palette.mode === 'dark'
            ? theme.palette.grey[900]
            : theme.palette.background.paper,
        boxShadow: theme.palette.mode === 'dark'
            ? '0px 4px 20px rgba(0, 0, 0, 0.5)'
            : theme.shadows[8],
        position: 'relative',
        overflow: 'hidden',
        '&:focus-visible': {
            outline: 'none'
        }
    }
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
    padding: theme.spacing(1.5, 2),
    backgroundColor: theme.palette.mode === 'dark'
        ? theme.palette.grey[900]
        : theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.mode === 'dark'
        ? theme.palette.grey[800]
        : theme.palette.grey[200]}`,
    '& .MuiTypography-h6': {
        color: theme.palette.mode === 'dark'
            ? theme.palette.grey[100]
            : theme.palette.text.primary,
        fontSize: '1rem',
        fontWeight: 600
    }
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    padding: theme.spacing(2.5, 2, 2, 2),
    backgroundColor: theme.palette.mode === 'dark'
        ? theme.palette.grey[900]
        : theme.palette.background.paper,
    '& .MuiGrid-container': {
        marginTop: 0
    },
    overflowX: 'hidden'
}));

export const HeaderContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .MuiIconButton-root': {
        padding: theme.spacing(0.5),
        marginRight: theme.spacing(-0.5),
        color: theme.palette.text.secondary,
        '&:hover': {
            backgroundColor: theme.palette.mode === 'dark'
                ? 'rgba(255, 255, 255, 0.08)'
                : 'rgba(0, 0, 0, 0.04)'
        }
    }
}));

export const IconContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& .MuiSvgIcon-root': {
        fontSize: 20,
        color: theme.palette.primary.main
    }
}));

export const FormContainer = styled('form')({
    width: '100%'
});

export const ButtonGroup = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2)
}));

export const LabelTypography = styled(Typography)(({ theme }) => ({
    marginBottom: '4px',
    fontWeight: 500,
    color: theme.palette.mode === 'dark'
        ? theme.palette.grey[300]
        : theme.palette.text.secondary,
    fontSize: '0.875rem'
}));

export const GridContainer = styled(Grid)(({ theme }) => ({
    width: '100%',
    margin: 0,
    '& .MuiGrid-item': {
        paddingTop: '12px',
        paddingBottom: '12px'
    },
    '& .MuiFormControlLabel-root': {
        marginLeft: -6,
        marginRight: 0
    }
}));
